import Vue from 'vue';
import VueApollo from 'vue-apollo';
import ECharts from 'vue-echarts';
import VueSnackbar from 'vue-snack';
import {use} from 'echarts/core';
import {CanvasRenderer} from 'echarts/renderers';
import {LineChart} from 'echarts/charts';
import VoerroTagsInput from '@voerro/vue-tagsinput';
import {GridComponent, TooltipComponent, TitleComponent, DataZoomComponent, LegendComponent} from 'echarts/components';
import * as VueGoogleMaps from 'vue2-google-maps';
import VCalendar from 'v-calendar';
import draggable from 'vuedraggable';
import VModal from 'vue-js-modal';
import apolloClient from './apolloClient';
import router from './router';
import store from './store';
import App from './app/App.vue';
import './app/mixins';
import './app/components';

Vue.component('TagsInput', VoerroTagsInput);
// Global register

Vue.use(VueSnackbar, {time: 3000});

Vue.use(VModal);

Vue.use(draggable);
// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {componentPrefix: 'vc'});
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.GOOGLE_MAPS_API_KEY,
    libraries: 'places'
  },
  installComponents: true
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

use([CanvasRenderer, LineChart, GridComponent, TooltipComponent, TitleComponent, DataZoomComponent, LegendComponent]);

// register globally (or you can do it locally)
Vue.component('VChart', ECharts);

Vue.use(VueApollo);
Vue.config.productionTip = process.env.NODE_ENV !== 'production';

export default new Vue({
  apolloProvider,
  components: {},
  render: h => h(App),
  store,
  router
}).$mount('#app');
